enum POPUP_TITLES {
    Confirmation = 'Confirmation',
    ChkMailingAddConfirmation = 'Check Mailing Address Confirmation',
    AgencyProfileCompletionAlert = 'Agency Profile Completion Alert',
    PageLeaveWarning = 'Unsaved Changes',
    ClientDeleteConfirmation = 'Client Delete Confirmation',
    FeeDeleteConfirmation = 'Fee Delete Confirmation',
    DeleteConfirmation = 'Delete Confirmation',
    AdditionalInfoNote = 'Additional Info Note',
    ResendCredentials = 'Resend Credentials',
    PrimaryContactConfirmation = 'Primary Contact Confirmation',
    Transaction_type_update_warning = 'Transaction Type Update Warning',
    Ask_For_Preapprove_tran = 'Pre-approve',
    Information = 'Information',
    FundNotAvailable = 'Fund Not Available',
    DebitCardNumber = 'USIO Card Number',
};
enum OLD_PREFERENCE_TRANSACTION_GRID_LABLES {
    CreatedDateandTime = 'Created Date and Time',
};

enum NEW_PREFERENCE_TRANSACTION_GRID_LABLES {
    CreatedDateandTime = 'Created Date',
};

enum FUNDING_SOURCE {
    Whatever_It_Takes = 'WIT',
    HPSP = 'HPSP',
    UpSkill_OC_CalOptima = 'Upskill1',
    Upskill_OC_Department_of_Veteran_Affairs = 'Upskill2',
    Upskill_OC_OYACPP_EDD = 'UOOE',
    WITY = 'WITY',
};

enum COGNITO_GROUPS {
    SuperAdminGroup = 'AdminGroup',
    FinanceGroup = 'FinanceGroup'
};

enum API_ACTIONS {
    Get = 'Get',
    Create = 'Create',    
    Delete = 'Delete'
};

enum PAYMENT_METHOD {
    USIO_CARD = 'USIO Card',
    CHECK = 'Check',
    ACH = 'ACH'
}

enum USIO_PAYMENT_TYPE {
    USIO_CARD_PHYSICAL = 'USIO Card (physical)',
    USIO_CARD_ELECTRONIC_TEXT = 'USIO Card (electronic text)',
    USIO_CARD_ELECTRONIC_EMAIL = 'USIO Card (electronic email)',
    USIO_CARD_ATM_ELECTRONIC_EMAIL = 'USIO Card/ATM (electronic email)',
    USIO_CARD_ATM_ELECTRONIC_TEXT = 'USIO Card/ATM (electronic text)'
}

export { POPUP_TITLES, OLD_PREFERENCE_TRANSACTION_GRID_LABLES, NEW_PREFERENCE_TRANSACTION_GRID_LABLES, FUNDING_SOURCE, COGNITO_GROUPS, API_ACTIONS, PAYMENT_METHOD , USIO_PAYMENT_TYPE };
